import { useState } from 'react'
import { Input } from '../../../components/input'
import { Header } from '../../../components/header'
import { Button } from '../../../components/button'
import { Footer } from '../../../components/footer'
import { brazilianStates } from '../../../assets/states/brazilianStates'
import { genderOptions } from '../../../assets/genderOptions/genderOptions'
import sickPerson from '../../../assets/images/medium-shot-sick-woman-home.jpg'
import './style.css'

export function CriarContaPaciente() {
  const [formData, setFormData] = useState({
    dateOfBirth: '',
    gender: '',
    email: '',
    fullName: '',
    state: '',
    city: '',
    address: '',
    password: '',
    confirmPassword: '',
    notifications: false,
    termsAccepted: true,
    privacyAccepted: true
  })

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    
    if (formData.password !== formData.confirmPassword) {
      alert('As senhas não coincidem!')
      return
    }

    alert('Conta criada com sucesso!')
  }

  return (
    <div className="create-account-patient-page">
      <Header />
      <main className="create-account-main">
        <div className="create-account-container">
          <div className="page-header">
            <h1 className="page-title">Meu VidaPlus</h1>
            <span className="page-subtitle">Portal Paciente</span>
          </div>
          
          <p className="page-description">Insira seus dados para prosseguir com seu cadastro</p>

          <div className="content-grid">
            <div className="form-section">
              <form className="account-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <Input 
                    Text="Data de Nascimento"
                    htmlFor="dateOfBirth"
                    type="date"
                    id="dateOfBirth"
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />

                  <div className="form-group">
                    <label htmlFor="gender">Gênero</label>
                    <select
                      id="gender"
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      required
                      className="form-select"
                    >
                      {genderOptions.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <Input 
                  Text="E-mail"
                  htmlFor="email"
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="seu.email@exemplo.com"
                />

                <Input 
                  Text="Nome Completo"
                  htmlFor="fullName"
                  type="text"
                  id="fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="Digite seu nome completo"
                />

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="state">Estado</label>
                    <select
                      id="state"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      required
                      className="form-select"
                    >
                      {brazilianStates.map(state => (
                        <option key={state.value} value={state.value}>
                          {state.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="city">Cidade</label>
                    <select
                      id="city"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      required
                      className="form-select"
                    >
                      <option value="">Selecione a cidade</option>
                      <option value="cidade1">Cidade 1</option>
                      <option value="cidade2">Cidade 2</option>
                      <option value="cidade3">Cidade 3</option>
                    </select>
                  </div>
                </div>
                
                <Input 
                  Text="Endereço"
                  htmlFor="address"
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="Rua, número, complemento"
                />

                <Input 
                  Text="Senha"
                  htmlFor="password"
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="Digite sua senha" 
                />

                <Input 
                  Text="Confirmar Senha"
                  htmlFor="confirmPassword"
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="Confirme sua senha" 
                />
                
                <div className="checkbox-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="notifications"
                      checked={formData.notifications}
                      onChange={handleChange}
                      className="checkbox-input"
                    />
                    <span>Aceito receber notificações e atualizações por email</span>
                  </label>
                </div>

                <div className="checkbox-group required">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="termsAccepted"
                      checked={formData.termsAccepted}
                      onChange={handleChange}
                      required
                      className="checkbox-input"
                      disabled
                    />
                    <span>Aceito os <a href="/termos" target="_blank">termos e condições</a></span>
                  </label>
                </div>

                <div className="checkbox-group required">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="privacyAccepted"
                      checked={formData.privacyAccepted}
                      onChange={handleChange}
                      required
                      className="checkbox-input"
                      disabled
                    />
                    <span>Aceito a <a href="/privacidade" target="_blank">política de privacidade</a></span>
                  </label>
                </div>
                
                <Button textBody="Criar Conta" type="submit" />
              </form>
            </div>

            <div className="image-section">
              <div className="image-card">
                <img src={sickPerson} alt="Portal do Paciente" className="card-image" />
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}
